import CheckoutComponent from "./CheckoutComponent";
import CheckoutDelivery from "./CheckoutDelivery";
import {GTM} from "../gtm";
export default class CheckoutTotal {
    static readonly getBalance: string = 'button.get-balance';
    static readonly confirmLoyaltyPhone: string = 'button.confirm-loyalty-phone';
    static readonly couponBtn: string = '.basket-coupon-block-coupon-btn';
    static readonly couponClose: string = '.coupon .close-link';
    static readonly loyaltyCheckbox: string = '.loyalty-change-input';
    static readonly balanceCheckbox: string = '.balance-change-input';
    static readonly url: string = '/?ajaxAction=';
    static readonly urlGetBounceBalance: string = CheckoutTotal.url + 'getBonusBalance';
    static readonly urlRequestBounceBalance: string = CheckoutTotal.url + 'requestBonusBalance';
    static readonly urlConfirmPhone: string = CheckoutTotal.url + 'confirmPhone';
    static readonly urlApplyCoupon: string = CheckoutTotal.url + 'applyCoupon';
    static readonly urlRemoveCoupon: string = CheckoutTotal.url + 'removeCoupon';
    private BX: any;
    static arComponentsReload: string[] = ['total'];

    constructor(BX: any) {
        this.BX = BX;
        if (typeof (CheckoutComponent.arResult.LOYALTY) == 'undefined') {
            CheckoutComponent.arResult.LOYALTY = {};
        }
    }

    init() {
        CheckoutTotal.getBonusBalance();
        this.bindEvents();

    }

    bindEvents() {
        let self = this;
        self.onClick(CheckoutTotal.getBalance);
        self.onClick(CheckoutTotal.confirmLoyaltyPhone);
        self.onClick(CheckoutTotal.couponBtn);
        self.onClick(CheckoutTotal.couponClose);
        self.onChange(CheckoutTotal.loyaltyCheckbox);
        self.onChange(CheckoutTotal.balanceCheckbox);
        $(document).on('click', '.btn-order-save', function () {
            self.saveOrder();
        });
    }

    onChange(el: string) {
        let self = this;
        let f;
        switch (el) {
            case CheckoutTotal.loyaltyCheckbox: {
                f = function (e: JQuery.ChangeEvent<Document, undefined, any, any>) {
                    self.toggleLoyaltyDiscount(e);
                }
                break;
            }
            case CheckoutTotal.balanceCheckbox: {
                f = function (e: JQuery.ChangeEvent<Document, undefined, any, any>) {
                    self.toggleBalanceDiscount(e);
                }
                break;
            }
        }
        $(document).on('change', el, f);
    }

    onClick(el: string): any {
        let self = this;
        let f = function (e: JQuery.ClickEvent<Document, undefined, any, any>) {
            switch (el) {
                case CheckoutTotal.getBalance: {
                    self.requestBonusBalance(e);
                    break;
                }
                case CheckoutTotal.confirmLoyaltyPhone: {
                    self.confirmPhone(e);
                    break;
                }
                case CheckoutTotal.couponBtn: {
                    self.applyCoupon(e);
                    break;
                }
                case CheckoutTotal.couponClose: {
                    self.removeCoupon(e);
                    break;
                }
            }

        };
        CheckoutComponent.onClick(el, f);
    }

    static getBonusBalance() {
        let self = this;
        let $loyaltyBlock = $('.checkout-loyalty-line');
        CheckoutComponent.post(
            CheckoutTotal.urlGetBounceBalance,
            {},
            function (data: { status: number; message: string | number | boolean | ((this: HTMLElement, index: number, text: string) => string | number | boolean); value: string | number; label: string; }) {
                $loyaltyBlock.removeClass('hidden');
                if(typeof(CheckoutComponent.arResult.LOYALTY) != 'undefined') {
                    CheckoutComponent.arResult.LOYALTY.HIDE = 'N';
                }
                if (data.status == 0) {
                    if (typeof data.message != 'undefined') {
                        $loyaltyBlock.html($('#checkout-loyalty-error-template').html());
                        $loyaltyBlock.find('.message').html(data.message);
                    } else {
                        $loyaltyBlock.empty();
                    }
                }
                if (data.status == 1) {
                    $loyaltyBlock.html($('#checkout-loyalty-balance-template').html());

                    CheckoutComponent.arResult.LOYALTY.BALANCE = (data.value as number);
                    CheckoutComponent.arResult.LOYALTY.LABEL = (data.label as string);
                    $loyaltyBlock.find('.message').empty();
                    $loyaltyBlock.find('input[type="checkbox"]').next('span').text(data.value + ' ' + data.label);
                    if(CheckoutComponent.arResult.LOYALTY.USE_DISCOUNT == 'Y') {
                        $loyaltyBlock.find('input[type="checkbox"]').prop('checked', true);
                    }
                }
                if (data.status == 2) {
                    $loyaltyBlock.html($('#checkout-loyalty-auth-template').html());
                }
            }
        )
    }

    requestBonusBalance(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        e.preventDefault();
        let $loyaltyBlock = $('.checkout-loyalty-line');
        $loyaltyBlock.find('button').prop('disabled', true);
        this.post(
            CheckoutTotal.urlRequestBounceBalance,
            {},
            false,
            function (data: { message: string | number | boolean | ((this: HTMLElement, index: number, text: string) => string | number | boolean); status: number; }) {
                $loyaltyBlock.find('button').prop('disabled', false);
                $loyaltyBlock.html($('#checkout-loyalty-confirm-phone-template').html());
                $loyaltyBlock.find('.message').text(data.message);
                if (data.status != 1) {
                    $loyaltyBlock.find('form').remove();
                }
            }
        );
    }

    confirmPhone(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let self = this;
        e.preventDefault();
        let $loyaltyBlock = $('.checkout-loyalty-line');
        let sCode = $(e.target).closest('.checkout-loyalty-line').find('input[name="CODE"]').val();
        if (!(sCode as string).length) {
            return;
        }
        $(e.target).prop('disabled', true);
        this.post(
            CheckoutTotal.urlConfirmPhone,
            {
                code: sCode
            },
            false,
            function (data: { status: number; value: number; message: string | number | boolean | ((this: HTMLElement, index: number, text: string) => string | number | boolean); label: string; }) {
                $(e.target).prop('disabled', false);
                if (data.status == 1) {
                    $loyaltyBlock.html($('#checkout-loyalty-balance-template').html());
                    self.setText(data, $loyaltyBlock);
                } else {
                    $loyaltyBlock.find('.message').text(data.message);
                }
            }
        );
    }

    setText(data: any, loyaltyBlock: any) {
        if (data.value < 1) {
            loyaltyBlock.find('.checkbox').hide();
            if (typeof (data.message) != 'undefined') {
                loyaltyBlock.find('.message').text(data.message);
            } else {
                loyaltyBlock.find('.message').text(data.value + ' ' + data.label);
            }
        } else {
            loyaltyBlock.find('.message').empty();
            loyaltyBlock.find('input[type="checkbox"]').next('span').text(data.value + ' ' + data.label);
        }
    }

    toggleLoyaltyDiscount(e: JQuery.ChangeEvent<Document, undefined, any, any>) {
        if ($(e.target).prop('checked')) {
            CheckoutComponent.arResult.LOYALTY.USE_DISCOUNT = "Y";
        } else {
            CheckoutComponent.arResult.LOYALTY.USE_DISCOUNT = "N";
        }
        CheckoutDelivery.calculateAllDeliveryServices();
    }

    toggleBalanceDiscount(e: JQuery.ChangeEvent<Document, undefined, any, any>) {
        if ($(e.target).prop('checked')) {
            CheckoutComponent.arResult.USE_USER_BALANCE = "Y";
        } else {
            CheckoutComponent.arResult.USE_USER_BALANCE = "N";
        }
        CheckoutComponent.reloadComponents(CheckoutTotal.arComponentsReload);
    }

    applyCoupon(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let coupon = $(e.target).closest('.form-group').find('input').val();
        let errorBlock = $('.checkout-coupon-line').find('span.error');
        errorBlock.empty();
        if (!coupon) {
            return false;
        }
        this.post(
            CheckoutTotal.urlApplyCoupon,
            {
                coupon: coupon
            },
            false,
            function (data: { status: number; message: string | number | boolean | ((this: HTMLElement, index: number, text: string) => string | number | boolean); }) {
                if (data.status == 1) {
                    CheckoutComponent.arResult.LOYALTY.USE_DISCOUNT = 'N';
                    CheckoutDelivery.calculateAllDeliveryServices();
                    CheckoutComponent.reloadComponents(['total', 'basket']);
                } else {
                    if (typeof (data.message) != 'undefined') {
                        errorBlock.text(data.message);
                    }
                }
            }
        )
    }

    removeCoupon(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        let coupon = $(e.target).data('coupon');
        if (!coupon) {
            return false;
        }
        this.post(
            CheckoutTotal.urlRemoveCoupon,
            {
                coupon: coupon
            },
            false,
            function (data: { status: number; message: string | number | boolean | ((this: HTMLElement, index: number, text: string) => string | number | boolean); }) {
                CheckoutDelivery.calculateAllDeliveryServices();
                CheckoutComponent.reloadComponents(['total', 'basket']);
            }
        )
    }

    reloadTotal() {
        return function (data: any) {
            if (data.status == 1) {
                CheckoutComponent.reloadComponents(CheckoutTotal.arComponentsReload);
            }
        }
    }

    post(href: string, data: any, reloadTotal: boolean, f?: any) {
        data.sessid = this.BX.bitrix_sessid();
        if (reloadTotal) {
            CheckoutComponent.post(
                href,
                data,
                this.reloadTotal()
            )
        } else {
            CheckoutComponent.post(
                href,
                data,
                f
            )
        }
    }

    saveOrder() {
        let $licenseInput = $('input[name="licenses_order"]');
        let $licenseBlock = $('.licence_block');
        if(!$licenseInput.prop('checked')) {
            $('html, body').animate({
                scrollTop: $licenseBlock.offset().top
            }, 150);
            $licenseBlock.find('.error').show();
            return false;
        }
        let $orderBtn = $('.btn-order-save');
        if($orderBtn.hasClass('disabled')) {
            return;
        }
        $('#checkout').find('.component-error-message, .error-message').hide();
        CheckoutComponent.arResult.COMMENT = $('#orderDescription').val();
        let self = this;
        $orderBtn.addClass('disabled').text('Оформляем заказ');
        CheckoutDelivery.checkPaySystem();

        $.post(
            '/',
            {
                ajaxAction: 'saveOrder',
                result: CheckoutComponent.arResult,
            },
            function(data) {
                $orderBtn.removeClass('disabled').text('Оформить заказ');
                if(data.status == 1) {
                    GTM.purchaseHandler(CheckoutComponent.arResult,data.orders);
                    document.location.href = document.location.pathname + '?ORDER_ID=' + data.orders.join('/');
                } else {
                    if(typeof(data.component) == 'undefined') {
                        data.component = 'checkout';
                    }
                    if(typeof(data.message) == 'undefined') {
                        data.message = 'Ошибка оформления заказа. Попробуйте позже.';
                    }
                    let input = typeof(data.input) == 'undefined' ? false : data.input;
                    self.showError(data.component, data.message, input);
                }
            },
            'json'
        );
    }

    showError(component: string, text:string, input:string) {
        let $component = component == 'checkout' ? $('#checkout') : $('#'+component+'-component');
        if(input) {
            $component.find('input[name="'+input+'"], select[name="'+input+'"]')
                .parent('div').find('.error-message')
                .text(text).show();
        } else {
            if(component == 'checkout') {
                $component.children('.component-error-message').text(text).show();
            } else {
                $component.find('.component-error-message').text(text).show();
            }
        }

        $('html, body').animate({
            scrollTop: component == 'checkout' ? 0 : ($component.offset().top-100)
        }, 150);
    }
}